import { TOptions } from 'i18next';
import React from 'react';
import { withTranslation, WithTranslationProps } from 'react-i18next';

interface TranslateProps extends WithTranslationProps {
    tkey: string[] | string;
    options?: TOptions | string;
}

class Translate extends React.Component<TranslateProps> {
    public render() {
        return this.props.i18n?.t(this.props.tkey, this.props.options);
    }
}

const connected = withTranslation()(Translate);

export { connected as Translate };
